import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";
import StudentDialog from "./components/form/StudentDialog.vue";
import CustomMaskedField from "./components/form/CustomMaskedField.vue";

Vue.config.productionTip = false;

Vue.component("student-dialog", StudentDialog);
Vue.component("masked-field", CustomMaskedField);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
